var _defs, _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _path5, _polygon4, _path6, _polygon5, _path7, _rect, _rect2, _path8, _rect3, _path9, _rect4, _path10, _path11, _path12, _rect5, _path13, _rect6, _path14, _rect7, _rect8, _rect9, _path15, _path16, _rect10, _path17, _path18, _path19, _path20, _path21, _polygon6, _path22, _path23, _path24, _ellipse, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon7, _path33, _path34, _path35, _ellipse2, _path36, _path37, _path38, _path39, _path40, _ellipse3, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _rect11, _path62, _circle, _circle2, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _circle3, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GROUND",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 1400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#262424;}.cls-2{fill:#de9244;}.cls-3{fill:#88c0c2;}.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Product documentation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1302.26,1243.23H756.19a2,2,0,1,1,0-4h546.06A2,2,0,0,1,1302.26,1243.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M719.43,1243.23H636a2,2,0,0,1,0-4h83.45A2,2,0,0,1,719.43,1243.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.63,1025.74c-80.46,0-145.92-65.46-145.92-145.92s65.46-145.92,145.92-145.92,145.92,65.46,145.92,145.92S553.08,1025.74,472.63,1025.74Zm0-287.83c-78.25,0-141.92,63.66-141.92,141.92s63.66,141.92,141.92,141.92,141.92-63.66,141.92-141.92S550.88,737.91,472.63,737.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M776.16,1151.92a68.45,68.45,0,1,1,68.45-68.45A68.53,68.53,0,0,1,776.16,1151.92Zm0-132.9a64.45,64.45,0,1,0,64.45,64.45A64.52,64.52,0,0,0,776.16,1019Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "436.51 895.98 436.51 1061.85 609.54 1167.7 609.54 1001.83 436.51 895.98"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "782.57 895.98 782.57 1061.85 609.54 1167.7 609.54 1001.83 782.57 895.98"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "782.57 895.98 719.43 934.61 672.67 963.21 609.54 1001.83 436.51 895.98 499.65 857.36 546.4 828.75 609.54 790.13 782.57 895.98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M609.54,1003.83a2,2,0,0,1-1-.29l-173-105.85a2,2,0,0,1,0-3.41l173-105.84a2,2,0,0,1,2.09,0l173,105.84a2,2,0,0,1,0,3.41l-173,105.85A2,2,0,0,1,609.54,1003.83ZM440.34,896l169.2,103.5L778.74,896l-169.2-103.5Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "719.43 934.61 672.67 963.21 499.65 857.36 546.4 828.75 719.43 934.61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M672.67,965.21a2,2,0,0,1-1-.29l-173-105.85a2,2,0,0,1,0-3.41L545.36,827a2,2,0,0,1,2.09,0l173,105.85a2,2,0,0,1,0,3.41l-46.76,28.6A2,2,0,0,1,672.67,965.21ZM503.48,857.36l169.19,103.5,42.93-26.25L546.4,831.1Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "672.67 963.21 719.43 934.61 719.43 981.23 672.67 1009.83 672.67 963.21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M672.67,1011.83a2,2,0,0,1-2-2V963.21a2,2,0,0,1,1-1.71l46.76-28.6a2,2,0,0,1,3,1.71v46.62a2,2,0,0,1-1,1.71l-46.76,28.6A2,2,0,0,1,672.67,1011.83Zm2-47.5v41.93l42.76-26.15V938.17Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 753.71,
    y: 740.97,
    width: 124.33,
    height: 24.33,
    rx: 12.17,
    ry: 12.17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 753.71,
    y: 789.97,
    width: 60.17,
    height: 24.33,
    rx: 12.17,
    ry: 12.17
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700.63,831.13a2,2,0,0,1-1-3.71l37.6-23a2,2,0,1,1,2.09,3.41l-37.6,23A2,2,0,0,1,700.63,831.13Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 343.03,
    y: 1122.86,
    width: 72.33,
    height: 24.33,
    rx: 12.17,
    ry: 12.17,
    transform: "translate(758.39 2270.06) rotate(-180)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.84,1133a2,2,0,0,1-1-3.71l37.6-23a2,2,0,1,1,2.09,3.41l-37.6,23A2,2,0,0,1,430.84,1133Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 603.38,
    y: 297.16,
    width: 305.63,
    height: 136.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M909,435.22H603.38a2,2,0,0,1-2-2V297.16a2,2,0,0,1,2-2H909a2,2,0,0,1,2,2V433.22A2,2,0,0,1,909,435.22Zm-303.63-4H907V299.16H605.38V431.22Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M603.38,158.77H341.07a43.33,43.33,0,0,0-43.33,43.33v95.06H603.38V158.77Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.38,299.16H297.74a2,2,0,0,1-2-2V202.1a45.38,45.38,0,0,1,45.33-45.33H603.38a2,2,0,0,1,2,2V297.16A2,2,0,0,1,603.38,299.16Zm-303.63-4H601.38V160.77H341.07a41.37,41.37,0,0,0-41.33,41.33v93.06Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 297.74,
    y: 297.16,
    width: 305.63,
    height: 136.06
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.38,435.22H297.74a2,2,0,0,1-2-2V297.16a2,2,0,0,1,2-2H603.38a2,2,0,0,1,2,2V433.22A2,2,0,0,1,603.38,435.22Zm-303.63-4H601.38V299.16H299.74V431.22Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 297.74,
    y: 433.22,
    width: 305.63,
    height: 136.06
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.38,571.28H297.74a2,2,0,0,1-2-2V433.22a2,2,0,0,1,2-2H603.38a2,2,0,0,1,2,2V569.28A2,2,0,0,1,603.38,571.28Zm-303.63-4H601.38V435.22H299.74V567.28Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 407.26,
    y: 491.32,
    width: 86.61,
    height: 19.86,
    rx: 9.93,
    ry: 9.93
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 407.26,
    y: 214.73,
    width: 86.61,
    height: 19.86,
    rx: 9.93,
    ry: 9.93
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 712.89,
    y: 355.26,
    width: 86.61,
    height: 19.86,
    rx: 9.93,
    ry: 9.93
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.74,569.28v95.06a43.33,43.33,0,0,0,43.33,43.33H603.38V569.28H297.74Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.38,709.67H341.07a45.38,45.38,0,0,1-45.33-45.33V569.28a2,2,0,0,1,2-2H603.38a2,2,0,0,1,2,2V707.67A2,2,0,0,1,603.38,709.67ZM299.74,571.28v93.06a41.37,41.37,0,0,0,41.33,41.33H601.38V571.28H299.74Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 603.38,
    y: 433.22,
    width: 305.63,
    height: 136.06
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M909,571.28H603.38a2,2,0,0,1-2-2V433.22a2,2,0,0,1,2-2H909a2,2,0,0,1,2,2V569.28A2,2,0,0,1,909,571.28Zm-303.63-4H907V435.22H605.38V567.28Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M603.38,569.28V707.67H865.68A43.33,43.33,0,0,0,909,664.34V569.28H603.38Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M865.68,709.67H603.38a2,2,0,0,1-2-2V569.28a2,2,0,0,1,2-2H909a2,2,0,0,1,2,2v95.06A45.38,45.38,0,0,1,865.68,709.67Zm-260.31-4H865.68A41.37,41.37,0,0,0,907,664.34V571.28H605.38V705.67Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M909,202.1a43.33,43.33,0,0,0-43.33-43.33H603.38V297.16H909V202.1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M909,299.16H603.38a2,2,0,0,1-2-2V158.77a2,2,0,0,1,2-2H865.68A45.38,45.38,0,0,1,911,202.1v95.06A2,2,0,0,1,909,299.16Zm-303.63-4H907V202.1a41.37,41.37,0,0,0-41.33-41.33H605.38V295.16Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1112.23 1076.24 1159.98 1112.38 1173.15 1093.09 1128.26 1052.16 1112.23 1076.24"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1160,1114.38a2,2,0,0,1-1.21-.41L1111,1077.84a2,2,0,0,1-.46-2.7l16-24.09a2,2,0,0,1,3-.37l44.9,40.93a2,2,0,0,1,.3,2.6l-13.17,19.29a2,2,0,0,1-1.33.85Zm-45-38.6,44.57,33.73,11-16.12-41.89-38.19Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1174.89,1235.63l8.76,5.6,69.17-108.3s-4.35-3.27-11.82-8.52a709.21,709.21,0,0,0-69-43.31l-27.62,31s11.92,49.38,19.09,91.13c0.74,4.33,1.33,8.77,1.69,13.28C1165.83,1225.19,1169.2,1232,1174.89,1235.63Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1183.78,1171.29a2,2,0,0,1-1.94-1.53c-9.21-38.44-22.41-61.5-22.54-61.73a2,2,0,1,1,3.46-2c0.13,0.23,13.62,23.75,23,62.81a2,2,0,0,1-1.48,2.41A2,2,0,0,1,1183.78,1171.29Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1201.76,
    cy: 1124.45,
    rx: 11.41,
    ry: 12.7,
    transform: "translate(-392.77 1531.98) rotate(-57.43)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1202.94,1138.24a15.61,15.61,0,0,1-8.39-2.49h0c-6.83-4.36-9.15-13-5.17-19.21a12.76,12.76,0,0,1,8.84-5.69,15.38,15.38,0,0,1,10.77,2.31c6.83,4.36,9.15,13,5.17,19.21A13.11,13.11,0,0,1,1202.94,1138.24Zm-6.24-5.86c5,3.18,11.29,2.2,14.08-2.17s1-10.51-4-13.69a11.4,11.4,0,0,0-8-1.73,8.81,8.81,0,0,0-6.12,3.9c-2.79,4.37-1,10.51,4,13.69h0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1174.89,1235.63l8.76,5.6,69.17-108.3s-4.35-3.27-11.82-8.52l-36.52,57.17s-27.8-12.61-41,21.67c0.74,4.33,1.33,8.77,1.69,13.28C1165.83,1225.19,1169.2,1232,1174.89,1235.63Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1183.65,1243.23a2,2,0,0,1-1.07-.31l-8.76-5.6h0c-6.13-3.91-9.92-11.24-10.68-20.62-0.34-4.24-.9-8.65-1.67-13.1a2,2,0,0,1,.11-1.06c4.54-11.75,11.25-19.51,20-23.07,9.5-3.88,18.54-1.58,22.15-.33l35.64-55.8a2,2,0,0,1,2.83-.56c7.42,5.21,11.83,8.53,11.88,8.56a2,2,0,0,1,.48,2.67l-69.17,108.3A2,2,0,0,1,1183.65,1243.23Zm-7.68-9.28,7.08,4.52,67.09-105c-1.64-1.21-4.59-3.36-8.58-6.18l-35.39,55.41a2,2,0,0,1-2.51.75c-0.1,0-10.25-4.5-20.66-.22-7.5,3.08-13.39,9.91-17.5,20.28,0.74,4.39,1.28,8.72,1.62,12.91,0.66,8.11,3.8,14.35,8.84,17.57h0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1136,743.8l-87.18,196.73,95.56,111.63-32.12,43.25s-87-64-130.07-104.82c-14.83-14.05-24.47-25.36-23.6-30.39,0.52-3,2.62-13.36,5.86-28.71,17.92-84.57,70.91-321.48,89.28-328.37,5.89-2.21,26.26-2.5,36.94-1.75,36.12,2.53,62.18,35.73,56.53,71.5Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1122,1056.79a2,2,0,0,1-1.49-.66L1019.13,943.36a2,2,0,0,1-.39-2l86.83-237.17a2,2,0,0,1,3.76,1.38l-86.42,236,100.62,111.88A2,2,0,0,1,1122,1056.79Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1104.14,1080.31a2,2,0,0,1-1.59-3.21l26.1-34.28a2,2,0,0,1,3.18,2.42l-26.1,34.28A2,2,0,0,1,1104.14,1080.31Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1115.87,713.62a2,2,0,0,1-1.25-.44l-12.43-10a17.6,17.6,0,0,1-6.61-13.78V638.61a2,2,0,0,1,4,0v50.81a13.62,13.62,0,0,0,5.11,10.67l12.43,10A2,2,0,0,1,1115.87,713.62Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M982.16,990.59c-14.83-14.05-24.47-25.36-23.6-30.39,0.52-3,2.62-13.36,5.86-28.71,8.14,4.32,15.44,12.86,19.47,24C988.63,968.5,987.61,981.77,982.16,990.59Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1171.27 1092.05 1172.01 1151.92 1195.32 1150.49 1200.12 1089.93 1171.27 1092.05"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1172,1153.92a2,2,0,0,1-2-2l-0.74-59.88a2,2,0,0,1,1.85-2l28.85-2.12a2,2,0,0,1,2.14,2.15l-4.79,60.56a2,2,0,0,1-1.87,1.84l-23.31,1.43H1172Zm1.28-60,0.69,55.89,19.48-1.2,4.47-56.51Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1076.16,1230.83v10.4h128.51s0.42-5.43.82-14.55a709.21,709.21,0,0,0-.66-81.49l-41-6.57s-35.2,36.63-66.52,65.14c-3.25,3-6.68,5.84-10.28,8.57C1080.08,1217.57,1076.16,1224.07,1076.16,1230.83Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1136.85,1204.62a2,2,0,0,1-1.44-3.39c27.48-28.49,39.77-52,39.89-52.23a2,2,0,0,1,3.55,1.84c-0.12.24-12.68,24.26-40.57,53.17A2,2,0,0,1,1136.85,1204.62Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1184.32,
    cy: 1193.63,
    rx: 11.41,
    ry: 12.7
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1184.32,1208.33c-7.39,0-13.41-6.6-13.41-14.7s6-14.7,13.41-14.7,13.41,6.59,13.41,14.7S1191.71,1208.33,1184.32,1208.33Zm0-25.4c-5.19,0-9.41,4.8-9.41,10.7s4.22,10.7,9.41,10.7,9.41-4.8,9.41-10.7S1189.51,1182.93,1184.32,1182.93Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1076.16,1230.83v10.4h128.51s0.42-5.43.82-14.55h-67.84s-4.34-30.22-40.36-22.93c-3.25,3-6.68,5.84-10.28,8.57C1080.08,1217.57,1076.16,1224.07,1076.16,1230.83Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1204.67,1243.23H1076.16a2,2,0,0,1-2-2v-10.4c0-7.27,4.13-14.41,11.63-20.1,3.39-2.57,6.81-5.42,10.14-8.46a2,2,0,0,1,1-.48c12.34-2.5,22.5-1,30.19,4.4,8.39,5.92,11.31,14.78,12.2,18.49h66.21a2,2,0,0,1,2,2.09c-0.4,9.05-.82,14.56-0.82,14.62A2,2,0,0,1,1204.67,1243.23Zm-126.51-4H1202.8c0.14-2,.36-5.67.59-10.55h-65.75a2,2,0,0,1-2-1.72c0-.11-1.73-11.07-10.94-17.53-6.64-4.66-15.56-5.95-26.51-3.83-3.29,3-6.66,5.77-10,8.31-6.48,4.92-10.05,10.92-10.05,16.91v8.4Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1253.63,622s-4.17,72.41-5.28,79.54-38.24,411.4-38.24,411.4l-56.83-.83L1120.72,640.2s-4.14-48.32,52.27-57.83S1253.63,622,1253.63,622Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1129.8,773.82a2,2,0,0,1-2-1.86l-9.15-128.3a2,2,0,1,1,4-.28l9.15,128.3a2,2,0,0,1-1.85,2.14h-0.14Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1164.84,
    cy: 895.98,
    rx: 21.63,
    ry: 30.95,
    transform: "translate(-42.49 58.13) rotate(-2.81)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1217.19,683.25a2,2,0,0,1-1.12-.34,35.15,35.15,0,0,1-15.49-28.46l-0.47-25.06a2,2,0,0,1,4-.08l0.47,25.06a31.14,31.14,0,0,0,13.73,25.22A2,2,0,0,1,1217.19,683.25Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1194.23,1098.41h-0.11a2,2,0,0,1-1.89-2.11l26.15-467.61a2,2,0,0,1,4,.22l-26.15,467.61A2,2,0,0,1,1194.23,1098.41Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1159.84,1099.08a2,2,0,0,1,0-4l47.63-.25h0a2,2,0,0,1,0,4l-47.63.25h0Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1051.06,328.26C1028.23,335,986.29,427.67,979,475.07s5,62.2,23.37,63.61,40.3-2.49,61.65-77.28S1093.31,315.85,1051.06,328.26Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1273.94,654.7h-22.6V628.44a7.23,7.23,0,0,0-14.46,0V654.7H1021.42s11.35-129.15,4.32-211.85c-7-82.14,25.32-114.58,25.32-114.58,121.43-27.67,184.05,6.74,184.05,6.74C1276.29,510.32,1273.94,654.7,1273.94,654.7Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1029.12,526.07a2,2,0,0,1-2-1.92c-0.41-9.66-.69-19.46-1-28.94-0.54-18.59-1-36.14-2.41-52.19-4.71-55.43,8.61-88.61,17-103.46a2,2,0,1,1,3.48,2c-8.14,14.44-21.1,46.79-16.48,101.15,1.37,16.16,1.88,33.77,2.42,52.41,0.27,9.47.56,19.26,1,28.89a2,2,0,0,1-1.91,2.08h-0.08Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1036.82,642a2,2,0,0,1,0-4L1228,636.61h0a2,2,0,0,1,0,4L1036.83,642h0Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1171.7,329.7a52.7,52.7,0,0,1-33.25,29.82c-2.48-13.6-9.31-30.71-9.31-30.71-7.59,10.44-11.6,24.26-12.59,30.56C1092,352.62,1089.19,329,1089.19,329c3-23.67,23.35-41.49,40.82-40.89C1168.62,289.42,1171.7,329.7,1171.7,329.7Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1138.45,361.52a2,2,0,0,1-2-1.64c-1.74-9.56-5.73-21-7.84-26.74a79.89,79.89,0,0,0-10.11,26.54,2,2,0,0,1-2.51,1.62c-25.57-7-28.79-31.81-28.82-32.06a2,2,0,0,1,0-.49c3.23-25.44,24.5-42.66,42-42.66h0.89c39.93,1.36,43.58,43,43.61,43.44a2,2,0,0,1-.16.94A55,55,0,0,1,1139,361.43,2,2,0,0,1,1138.45,361.52Zm-9.31-34.71,0.25,0a2,2,0,0,1,1.61,1.24c0.27,0.67,6.22,15.66,9,28.83a50.77,50.77,0,0,0,29.68-27.52c-0.48-4.64-5.18-38.1-39.72-39.27h-0.76c-15.7,0-35,16.34-38,38.9,0.35,2.42,3.72,21.14,23.79,27.81,1.43-6.84,5.32-19.26,12.53-29.17A2,2,0,0,1,1129.14,326.81Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1152.62,240.4L1152,264.13l-1.07,40.6c-13.66,9.55-26.94,10.55-39.75.93L1113,286.8l2.84-28.57Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1129.71,314.4q-10.22,0-19.75-7.14a2,2,0,0,1-.79-1.8l4.72-47.43a2,2,0,0,1,1.12-1.6l36.74-17.84a2,2,0,0,1,2.87,1.85l-1.7,64.33a2,2,0,0,1-.85,1.59C1144.4,311.73,1136.93,314.4,1129.71,314.4Zm-16.44-9.68c11.17,7.92,22.86,7.57,35.67-1.06l1.59-60-32.77,15.91Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1092.1,419.69c-18.59,68.3-44.2,106.2-67.17,120.35-14.3,8.83-27.58,8.44-37.5.46a27.3,27.3,0,0,1-9.31-14c-6.42-22.49,13-52.61,13-52.61l72-75.73Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1035.94,533.56a2,2,0,0,1-1.36-3.47c21.7-20.07,41.29-59,55.23-109.62l-26.42-19.68L996.7,470.9a2,2,0,1,1-2.9-2.76l67.91-71.39a2,2,0,0,1,2.64-.23l28.94,21.55a2,2,0,0,1,.74,2.13c-18.14,66.65-40.87,98.14-56.73,112.82A2,2,0,0,1,1035.94,533.56Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1080,433.38c-19.52,0-27.27-18.78-27.35-19a2,2,0,0,1,3.71-1.49h0c0.31,0.77,7.8,18.71,27.21,16.24a2,2,0,0,1,.5,4A32.45,32.45,0,0,1,1080,433.38Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1024.93,540c-14.3,8.83-27.58,8.44-37.5.46a27.3,27.3,0,0,1-9.31-14,27.1,27.1,0,0,1,4.79-10.61c8.52-11.5,24.2-14.32,35-6.31C1027.27,516.5,1029.91,529.28,1024.93,540Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1111.54,381.71c-7.42-1.63-20.87,24.75-12.62,29.61S1131.43,386.08,1111.54,381.71Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1101,413.84a6,6,0,0,1-3.07-.8c-4.18-2.46-4.71-9-1.41-17.36,2.7-6.88,9.29-17.27,15.47-15.92h0c6.37,1.4,8.41,5.11,9,8,1.66,8.09-6.21,18.66-12.53,23.18C1105.72,412.85,1103.17,413.84,1101,413.84Zm9.83-30.21c-2.47,0-7.55,5.74-10.59,13.51-2.41,6.13-2.52,11.14-.28,12.45,1.17,0.69,3.54-.05,6.18-1.94,6.12-4.37,12.09-13.48,10.93-19.12-0.51-2.51-2.46-4.1-5.94-4.87h0A1.38,1.38,0,0,0,1110.81,383.64Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1112.48,402.2v0.48l0,14.2-9.64-10.56-0.26-.28a5.74,5.74,0,0,1-.95-1.59l-29.82-77.17a5.63,5.63,0,0,1,10.5-4.05l29.82,77.16A5.57,5.57,0,0,1,1112.48,402.2Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1112.46,418.88a2,2,0,0,1-1.48-.65l-9.89-10.82a7.82,7.82,0,0,1-1.34-2.21L1069.92,328a7.63,7.63,0,0,1,14.23-5.49L1114,399.66a7.57,7.57,0,0,1,.5,2.47s0,0,0,.06l0,14.68A2,2,0,0,1,1112.46,418.88ZM1077,321.63a3.63,3.63,0,0,0-3.39,4.93l29.82,77.17a3.72,3.72,0,0,0,.61,1l0.2,0.21,6.18,6.77v-9.49a3.58,3.58,0,0,0-.24-1.13l-29.82-77.15A3.63,3.63,0,0,0,1077,321.63Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1076,370.63s-16.45,17.08-15.86,30.68,22.34,24.66,34.18,17,13-26,3.43-34c0,0,11.45,10.3,16.41,1.91s-21-25.57-29-24.42A10.82,10.82,0,0,0,1076,370.63Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1085.07,422.83a29.24,29.24,0,0,1-13.29-3.44c-8.11-4.19-13.33-11.09-13.63-18-0.58-13.2,13.34-28.84,16-31.71a12.76,12.76,0,0,1,10.73-9.81c7-1,23.87,9.15,29.65,17.8,3.09,4.62,2.44,7.79,1.36,9.63a8.18,8.18,0,0,1-5.87,4.18,11.41,11.41,0,0,1-5.41-.64,25,25,0,0,1-9.2,29.19A18.94,18.94,0,0,1,1085.07,422.83Zm1-59a4.41,4.41,0,0,0-.63,0,8.79,8.79,0,0,0-7.47,7.11,2,2,0,0,1-.54,1.08c-0.16.17-15.85,16.63-15.3,29.2,0.24,5.48,4.64,11.09,11.47,14.62,7,3.64,14.74,4,19.62.81a20.28,20.28,0,0,0,8.86-15.88c0.37-5.85-1.6-11.25-5.28-14.57l-0.41-.35a2,2,0,0,1,2.62-3l0.41,0.35c1.93,1.62,6.6,4.85,10,4.33a4.16,4.16,0,0,0,3-2.26c0.91-1.54-.17-3.77-1.24-5.37C1106.2,372.41,1091.69,363.79,1086.07,363.79ZM1076,370.63h0Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1052.44,
    y: 416.88,
    width: 136.72,
    height: 165.32,
    rx: 12.14,
    ry: 12.14
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1177,584.19H1064.57a14.15,14.15,0,0,1-14.14-14.14V429a14.15,14.15,0,0,1,14.14-14.14H1177A14.15,14.15,0,0,1,1191.16,429v141A14.15,14.15,0,0,1,1177,584.19ZM1064.57,418.88A10.15,10.15,0,0,0,1054.44,429v141a10.15,10.15,0,0,0,10.14,10.14H1177a10.15,10.15,0,0,0,10.14-10.14V429A10.15,10.15,0,0,0,1177,418.88H1064.57Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1101.79,
    cy: 432.49,
    r: 3.88
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1139.81,
    cy: 432.49,
    r: 3.88
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1300.81,546.57c-3.18,9.46-15.87,13.52-31.19,14.76-29.64,2.41-69.19-5.7-69.19-5.7V505l27.56-4.08s-15-71.38-19.73-102.78c-7.83-52,26.85-63.13,26.85-63.13,29.7,12.63,59.14,119.34,65.77,177.68C1302.67,528.45,1302.79,540.68,1300.81,546.57Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1300.81,546.57c-3.18,9.46-15.87,13.52-31.19,14.76-8.88-10.84-7.92-27.57,2.75-39,7.78-8.3,18.73-11.64,28.51-9.68C1302.67,528.45,1302.79,540.68,1300.81,546.57Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1257.76,563.77c-27.24,0-57.42-6.12-57.73-6.19a2,2,0,0,1-1.6-2V505a2,2,0,0,1,1.71-2l25.46-3.77c-2.5-12-15.09-72.73-19.32-100.82-5.82-38.67,11.15-55.54,21.79-62.15a2,2,0,0,1,2.11,3.4c-9.8,6.1-25.43,21.76-19.95,58.16,4.66,31,19.56,102,19.71,102.67a2,2,0,0,1-1.66,2.39l-25.85,3.82V554c6.82,1.3,34.16,6.18,58.17,5.77h0a2,2,0,0,1,0,4Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1217,552.24a2,2,0,0,1-1.86-2.74c7.46-18.83-4.72-38.51-4.84-38.71a2,2,0,0,1,3.38-2.14c0.55,0.87,13.4,21.56,5.18,42.31A2,2,0,0,1,1217,552.24Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1260.63,511.73a2,2,0,0,1-1-.27c-13.77-8-31.52-8.53-31.7-8.54a2,2,0,0,1-1.95-2,2,2,0,0,1,2-1.95c0.77,0,18.93.56,33.6,9.07A2,2,0,0,1,1260.63,511.73Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1205.39,515.47s6.4,24.55-1.27,36.92-33.76,11.3-40.8-2,1.49-31,14.58-33.48c0,0-16.08,3.62-16.31-6.81s33-12.86,39.85-7.59S1205.39,515.47,1205.39,515.47Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185,563l-1.22,0c-10.08-.35-18.6-4.84-22.24-11.72a26.63,26.63,0,0,1,6.91-32.06,12.28,12.28,0,0,1-5.62-2.26,8.62,8.62,0,0,1-3.24-6.86c0-2.25,1-5.48,6.23-8.14,9.89-5,30.89-5.64,36.83-1.09a13.51,13.51,0,0,1,4.81,14.65c1,4,5.79,25.88-1.65,37.89C1202.11,559.43,1194.21,563,1185,563ZM1177.78,519c-5.21,1.18-9.91,5.22-12.65,10.9a21.83,21.83,0,0,0,0,19.58c2.92,5.53,10.32,9.3,18.84,9.59,8.27,0.28,15.37-2.66,18.49-7.7,7.13-11.49,1.1-35.12,1-35.36a2,2,0,0,1,.06-1.21,9.54,9.54,0,0,0-3.29-10.69c-4.39-3.36-23.63-3.07-32.59,1.48-1.87.95-4.08,2.5-4,4.49a4.64,4.64,0,0,0,1.7,3.8c2.92,2.28,9,1.72,11.64,1.21l0.59-.12a2,2,0,0,1,.81,3.92Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1079.75,256.54c4.94,19,14.12,41.2,36.71,34,26.86-8.54,41.63-30.76,37.82-57s-18.17-39.12-49.07-31.26a48.69,48.69,0,0,0-7.68,2.63c-17.29,7.66-24,24-20.2,41.4C1078,249.48,1078.8,253,1079.75,256.54Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1108.2,293.93a21.5,21.5,0,0,1-10.55-2.67c-11.46-6.32-16.81-22.56-19.84-34.22-1-3.63-1.76-7.2-2.43-10.26-4.25-19.21,3.93-35.94,21.34-43.66a2,2,0,0,1,1.62,3.66c-15.57,6.9-22.88,21.9-19.06,39.14,0.67,3,1.46,6.55,2.4,10.12,2.85,11,7.8,26.15,17.91,31.73,4.69,2.59,10,2.88,16.26.89a56.63,56.63,0,0,0,25.32-15.84,2,2,0,1,1,3,2.66,60.62,60.62,0,0,1-27.1,17A29.25,29.25,0,0,1,1108.2,293.93Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1163.23,237.22a81.41,81.41,0,0,1-7.23,12.14l-13.75,3-4.48-9.37s-8.87,1-11.61-4.69a3.48,3.48,0,0,1-.18-0.4c-0.77-1.87-3.92-10.28-4.7-24,0,0-19.72,12.63-31.06,15.63-4.08,1.08-9.16.24-14-1.29-9.71-3.06-19.87-16.54-19.84-26.72q0-.1,0-0.2c0.22-15,9.37-6,9.37-6s0.35-12.06,7.57-14,13.58,8.13,13.58,8.13a117.08,117.08,0,0,1,42.75-8.47c29.07-.07,25,20.59,25,20.59S1176.59,205,1163.23,237.22Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1145,250.42c-2.89-10.76,3.23-22.11,14-25.06a18.55,18.55,0,0,1,7-.58c14.12,1.56,15.46,33.66-18.08,36.4Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1147.92,263.17a2,2,0,0,1-.16-4c18.72-1.53,25.51-12.3,25.64-21.06,0.09-6.08-3.12-10.86-7.62-11.36a16.57,16.57,0,0,0-6.25.52A18.4,18.4,0,0,0,1147,249.9a2,2,0,1,1-3.86,1c-3.21-12,3.68-24.3,15.37-27.51a20.59,20.59,0,0,1,7.75-.64c6.59,0.73,11.29,7.2,11.18,15.39-0.16,11.26-9.29,23.36-29.31,25h-0.17Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1273.96,
    cy: 245.98,
    r: 12.99
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M972.71,200a2,2,0,0,1-2-2V184.48a2,2,0,1,1,4,0V198A2,2,0,0,1,972.71,200Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M993.18,206.95H979.61a2,2,0,0,1,0-4h13.57A2,2,0,0,1,993.18,206.95Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M972.71,227.41a2,2,0,0,1-2-2V211.84a2,2,0,0,1,4,0v13.57A2,2,0,0,1,972.71,227.41Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M965.82,206.95H952.25a2,2,0,0,1,0-4h13.57A2,2,0,0,1,965.82,206.95Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.28,1157.28a2,2,0,0,1-2-2v-11.58a2,2,0,0,1,4,0v11.58A2,2,0,0,1,918.28,1157.28Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935.74,1163.17H924.16a2,2,0,1,1,0-4h11.58A2,2,0,1,1,935.74,1163.17Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.28,1180.63a2,2,0,0,1-2-2V1167a2,2,0,0,1,4,0v11.58A2,2,0,0,1,918.28,1180.63Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M912.39,1163.17H900.82a2,2,0,1,1,0-4h11.58A2,2,0,1,1,912.39,1163.17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.a82e92618e9d637793d2e6a70771fc65.svg";
export { ForwardRef as ReactComponent };